'use strict';

var compareEquip = function () {
  var nVersions = 3;
  var model = void 0,
      json = void 0,
      selectors = void 0,
      totalVersions = [],
      visibleVersions = [],
      slideInstance = void 0,
      moi = void 0;
  var changingId = void 0,
      changingIndex = void 0,
      orderedVersions = [],
      lcv = void 0;
  var comparatorData = void 0;

  var _setComparatorData = function _setComparatorData(value) {
    return comparatorData = value;
  };
  var _getComparatorData = function _getComparatorData() {
    return comparatorData;
  };

  var _setModel = function _setModel(value) {
    return model = value;
  };
  var _getModel = function _getModel() {
    return model;
  };
  var _setJson = function _setJson(value) {
    return json = value;
  };
  var _getJson = function _getJson() {
    return json;
  };

  var _setSelectors = function _setSelectors(value) {
    return selectors = value;
  };
  var _getSelectors = function _getSelectors() {
    return selectors;
  };

  var _setVisibleVersions = function _setVisibleVersions(array) {
    visibleVersions = array.slice();
  };
  var _getVisibleVersions = function _getVisibleVersions() {
    return visibleVersions;
  };

  var _setTotalVersions = function _setTotalVersions(array) {
    totalVersions = array.slice();
  };

  var _getTotalVersions = function _getTotalVersions() {
    return totalVersions;
  };

  var _setChangingId = function _setChangingId(value) {
    return changingId = value;
  };
  var _getChangingId = function _getChangingId() {
    return changingId;
  };

  var _setChangingIndex = function _setChangingIndex(value) {
    return changingIndex = value;
  };
  var _getChangingIndex = function _getChangingIndex() {
    return changingIndex;
  };

  var _setOrderedVersions = function _setOrderedVersions(value) {
    return orderedVersions = value.slice();
  };
  var _getOrderedVersions = function _getOrderedVersions() {
    return orderedVersions;
  };

  var _setLCV = function _setLCV(value) {
    return lcv = value;
  };
  var _getLCV = function _getLCV() {
    return lcv;
  };

  var _setMOI = function _setMOI(value) {
    return moi = value;
  };
  var _getMOI = function _getMOI() {
    return moi;
  };

  var slide_html = function slide_html(data, index) {
    return '\n    <div class="h-slide comparator_1-carrousel js-slide" data-id="' + data.id + '" data-index="' + index + '">\n      <div class="container">\n        <div class="comparator_1-carrousel_content">\n          <div class="data-container">\n            <p style="display:none">' + data.id + '</p>\n            <h3 class="comparator_1-carrousel-title">' + data.nombre + '</h3>\n            <p class="comparator_1-carrousel-xtra js-xtra-info"></p>\n            <button class="h-btn grey js-change-version" data-id="' + data.id + '" data-index="' + index + '">CAMBIAR</button>\n          </div>\n        </div>\n      </div>\n    </div>\n    ';
  };

  var _buildVersionSlides = function _buildVersionSlides() {
    var versions = _getJson().versiones;
    var slider = _getSelectors().versionSlider;
    var totalVersions = [];

    if (typeof slideInstance !== 'undefined') {
      slideInstance.slick('unslick');
    }
    $(slider).empty().css('visibility', 'hidden');

    for (var i = 0; versions[i]; i++) {
      totalVersions.push(versions[i].id);
      utils.render(slide_html(versions[i], i), slider);
    }

    _loadVersionsData();

    _setTotalVersions(totalVersions);

    function _goSlick() {
      $(slider).removeAttr('style');
      _launchSlick($(slider));
    }
    window.setTimeout(_goSlick, 1300);

    _addListToButton(slider);
  };

  var _launchSlick = function _launchSlick($slider) {
    slideInstance = $slider.slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      infinite: false
    });
    slideInstance.on('afterChange', function (event, slick, currentSlide) {
      var $slide = $(slick.$slides[currentSlide]);
      _buildCompTables(currentSlide);
    });
    if (typeof _getChangingIndex() !== 'undefined') {
      var goto = _getChangingIndex() > _getTotalVersions().length - 3 ? _getTotalVersions().length - 3 : _getChangingIndex();
      slideInstance.slick('slickGoTo', goto, true);
    }
  };

  var _addListToButton = function _addListToButton(slider) {
    $(slider).find('.js-change-version').on('click', function () {
      _setChangingId($(this).data('id'));
      console.log('El id que se va a cambiar es', _getChangingId());
      _setChangingIndex($(this).data('index'));
      changeVersToCompare.openDialog(_getLCV());
    });
  };

  var category_html = function category_html(data, index) {
    return '\n    <div class="toggle__item js-top-container-' + index + '">\n      <input class="toggle__input" id="section-' + index + '" type="checkbox" />\n      <label class="toggle__label" for="section-' + index + '">' + data.categoria + '</label>\n      <div class="toggle__content">\n        <table id="jsTable' + index + '" class="comparator_1-table">\n\n        </table>\n      </div>\n    </div>\n  ';
  };

  var _buildCategoryBlocks = function _buildCategoryBlocks() {
    var categories = _getJson().equipamiento;
    var domElem = _getSelectors().equipCategories;
    $(domElem).empty();
    var $block = void 0;
    for (var i = 0; categories[i]; i++) {
      $block = utils.render(category_html(categories[i], i), domElem);
      var $table = $($block.find('#jsTable' + i));
      _buildItems(categories[i].items, '#jsTable' + i);
    }
  };

  var row_html = function row_html(data, index) {
    return '\n    <tr class="js-row-' + index + '">\n      <td>' + data.descripcion + '</td>\n    </tr>\n  ';
  };

  var cell_html = function cell_html(text, id) {
    var val = text;
    if (text === 'Si') val = '<span class="tick"></span>';
    if (text === 'No') val = '<span class="vane"></span>';
    return '<td class="js-cell js-cell-' + id + '">' + val + '<p style="display:none">' + id + '</p></td>';
  };

  var _buildItems = function _buildItems(array, $table) {
    for (var i = 0; array[i]; i++) {
      utils.render(row_html(array[i], i), $table);
    }
  };

  var _buildCompTables = function _buildCompTables(initialIndex) {
    $('.js-cell').remove();
    var maxIndex = initialIndex + (nVersions - 1);
    var ids = [];
    for (var i = initialIndex; i <= maxIndex; i++) {
      ids.push($($('.js-slide')[i]).attr('data-id'));
    }
    _setVisibleVersions(ids);
    var nCategories = _getJson().equipamiento.length;
    for (var _i = 0; _i < nCategories; _i++) {
      var table = $('.js-top-container-' + _i).find('.js-table');
      for (var n = 0; n < _getJson().equipamiento[_i].items.length; n++) {
        var cellsValues = _getJson().equipamiento[_i].items[n].valores;
        for (var x = 0; x < cellsValues.length; x++) {
          for (var prop in cellsValues[x]) {
            if (_getVisibleVersions().indexOf(prop) > -1) {
              var cell = cell_html(cellsValues[x][prop], prop);
              $('#jsTable' + _i).find('.js-row-' + n).append(cell);
            }
          }
        }
        $('#jsTable' + _i).find('.js-row-' + n).append('<td class="js-cell pad-right-cell"></td>');
      }
    }
  };

  var _init = function _init(model, paramsString, selectorsObj, lcv, moi) {
    var url = globalEnv + 'servicios/getitemscomparador?modelo=' + model + '&moi=' + moi + '&mercado=ES';
    _setModel(model);
    _setSelectors(selectorsObj);
    _setLCV(lcv);
    _setMOI(moi);
    _load(url, false);
  };

  var _loadVersionsData = function _loadVersionsData() {
    var versData = void 0;
    var url = globalEnv + 'servicios/getcombinacionescomparador?modelo=' + _getModel() + '&moi=' + _getMOI() + '&mercado=ES';
    $.getJSON(url, function (data) {
      return versData = data;
    }).done(function () {
      if (versData.length > 1) {
        $('.js-depends-on-data').removeClass('hidden');
      }
      _putXtraData(versData);
    });
  };

  var _setXtra = function _setXtra(data) {
    var isLCV = _getLCV();
    var defaultContent = data.vdisplaymotor + ' <br> ' + data.vtransmision + ' / ' + data.vtraccion;
    var largeContent = '<strong>' + data.vcarroceria + '</strong><br> ' + (data.vcarrozado !== 'NO' ? data.vcarrozado + ' / ' : '') + ' ' + (data.vconfig !== 'NO' ? data.vconfig : '') + ' <br> ' + defaultContent + ' <br> ' + (data.vmma !== 'NO' ? data.vmma + ' kg M.M.A.' : '');
    if (!isLCV) {
      return defaultContent;
    } else {
      return largeContent;
    }
  };

  var _putXtraData = function _putXtraData(data) {
    _setComparatorData(data);
    var slider = _getSelectors().versionSlider;
    var slides = $(slider).find('.js-slide');

    for (var i = 0; slides[i]; i++) {
      var $slide = $(slides[i]);
      var myId = $slide.data('id');
      for (var j = 0; data[j]; j++) {
        if (data[j].vidgrau === myId) {
          var xtraContent = _setXtra(data[j]);
          $slide.find('.js-xtra-info').html(xtraContent);
        }
      }
    }
  };
  var _load = function _load(url, order) {
    var jsonData = void 0;
    $.getJSON(url, function (data) {
      return jsonData = data;
    }).done(function () {
      if (order) {
        jsonData = _orderJson(jsonData);
      }
      _setJson(jsonData);
      _buildVersionSlides();
      _buildCategoryBlocks();
      _buildCompTables(0);
    });
  };

  var _orderJson = function _orderJson(json) {
    var pattern = _getOrderedVersions();
    var jsonEquip = json.equipamiento,
        jsonVers = json.versiones;
    // Iterating equipment items to order comparison values
    for (var a = 0; jsonEquip[a]; a++) {
      var items = jsonEquip[a].items;
      for (var aa = 0; items[aa]; aa++) {
        var values = items[aa].valores;
        items[aa].valores = _orderedCompValues(values, pattern);
      }
    }
    // Iterating versions to order
    json.versiones = _orderedVersions(jsonVers, pattern);
    return json;
  };

  var _orderedVersions = function _orderedVersions(versions, pattern) {
    var result = [];
    for (var a = 0; pattern[a]; a++) {
      for (var aa = 0; versions[aa]; aa++) {
        if (pattern[a] === versions[aa].id) {
          result.push(versions[aa]);
        }
      }
    }
    return result;
  };

  var _orderedCompValues = function _orderedCompValues(values, pattern) {
    var result = [];
    for (var i = 0; pattern[i]; i++) {
      var newVal = {};
      for (var j = 0; values[j]; j++) {
        if (typeof values[j][pattern[i]] !== 'undefined') newVal[pattern[i]] = values[j][pattern[i]];
      }
      result.push(newVal);
    }
    return result;
  };

  var _reload = function _reload(newId) {
    var versions = _getTotalVersions();
    var ind = versions.indexOf(String(_getChangingId()));
    versions[ind] = newId;
    /* let paramsString = ''*/
    _setOrderedVersions(versions);
    var model = _getModel();
    var moi = _getMOI();
    $('.js-test').text(versions.join('-'));
    var url = globalEnv + 'servicios/getitemscomparador?modelo=' + model + '&moi=' + moi + '&grados=' + versions.join('-') + '&mercado=ES';
    _load(url, true);
  };
  return {
    init: _init,
    getModel: _getModel,
    reload: _reload,
    getTotalVersions: _getTotalVersions,
    slide: slideInstance,
    getComparatorData: _getComparatorData,
    getMOI: _getMOI
  };
}();